import { Menu, MenuItem } from '@material-ui/core';
import { AsYouType, isValidPhoneNumber } from 'libphonenumber-js/mobile';
import * as React from 'react';
import classnames from 'classnames';
import Input, { parsePhoneNumber } from 'react-phone-number-input/input';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input/input';
import en from 'react-phone-number-input/locale/en.json';
import sv from 'react-phone-number-input/locale/sv.json';
import { useIntl } from 'react-intl';
export const PhoneCountrySelect = ({ onSelect, value, className }) => {
    const intl = useIntl();
    const [countries] = React.useState(getCountries()
        .map((country) => {
        return {
            code: country,
            name: intl.locale === 'sv' ? sv[country] : en[country],
            callingCode: getCountryCallingCode(country)
        };
    })
        .sort((a, b) => a.name.localeCompare(b.name, intl.locale)));
    const [selectedValue, setSelectedValue] = React.useState(value);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    React.useEffect(() => {
        if (selectedValue !== value) {
            setSelectedValue(value);
        }
    }, [value]);
    const onHandleChange = (value) => {
        setSelectedValue(value);
        onSelect(value);
        handleClose();
    };
    const onClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className, onClick: onClick },
            React.createElement("img", { loading: "lazy", width: "20", src: `https://flagcdn.com/w20/${selectedValue.toLowerCase()}.png`, srcSet: `https://flagcdn.com/w40/${selectedValue.toLowerCase()}.png 2x`, alt: selectedValue }),
            React.createElement("span", { style: { marginLeft: '8px' } },
                "+",
                getCountryCallingCode(selectedValue)),
            React.createElement("span", { className: 'gg-chevron-down' })),
        React.createElement(Menu, { id: "long-menu", anchorEl: anchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, keepMounted: true, open: open, onClose: handleClose, PaperProps: {
                style: {
                    maxHeight: 450,
                },
            } }, countries.map((country) => (React.createElement(MenuItem, { key: country.code, selected: country.code === selectedValue, onClick: () => onHandleChange(country.code) },
            React.createElement("img", { style: { marginRight: '0.5em' }, loading: "lazy", width: "20", src: `https://flagcdn.com/w20/${country.code.toLowerCase()}.png`, srcSet: `https://flagcdn.com/w40/${country.code.toLowerCase()}.png 2x`, alt: "" }),
            country.name,
            " (+",
            country.callingCode,
            ")"))))));
};
const tryGetCountry = (text, defaultCountry) => {
    if (!text) {
        return defaultCountry;
    }
    const numberParse = new AsYouType(defaultCountry);
    numberParse.input(text);
    return numberParse.getCountry() || defaultCountry;
};
const formatNumber = (text, defaultCountry) => {
    if (!text) {
        return null;
    }
    const numberParse = new AsYouType(defaultCountry);
    numberParse.input(text);
    return numberParse.getNumberValue();
};
const PhoneNumberInput = ({ initialValue, initialCountry, placeholder, className, style, onBlur, setPhonenumberError }) => {
    const [country, setCountry] = React.useState(() => tryGetCountry(initialValue, initialCountry || 'SE'));
    const [number, setNumber] = React.useState(() => formatNumber(initialValue, country));
    const [hasError, setHasError] = React.useState(false);
    React.useEffect(() => {
        if (initialValue !== null && initialValue !== undefined && initialValue.length > 0) {
            const isInitialValueValid = isValidPhoneNumber(initialValue);
            setHasError(!isInitialValueValid);
            if (setPhonenumberError !== null && setPhonenumberError !== undefined) {
                setPhonenumberError(!isInitialValueValid);
            }
            const phoneNumber = parsePhoneNumber(initialValue);
            if (phoneNumber !== undefined && phoneNumber !== null && phoneNumber.country !== null && phoneNumber.country !== undefined) {
                setCountry(tryGetCountry(initialValue, phoneNumber.country));
                setNumber(formatNumber(initialValue, phoneNumber.country));
            }
        }
    }, []);
    const onSelectCountry = (c) => {
        setCountry(c);
    };
    const onChangeValue = (value) => {
        setNumber(value);
        if (!value) {
            setHasError(false);
            return;
        }
        const probablyAPhoneNumber = isValidPhoneNumber(value, country);
        setHasError(!probablyAPhoneNumber);
        const numberParser = new AsYouType(country);
        numberParser.input(value);
        const currentCountry = numberParser.getCountry();
        if (currentCountry && currentCountry !== country) {
            setCountry(currentCountry);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classnames('phone-number-input', { 'phone-number-input--hasError': hasError }, className), style: style },
            React.createElement(PhoneCountrySelect, { className: 'phone-number-country-selector', onSelect: onSelectCountry, value: country }),
            React.createElement(Input, { className: 'phone-number-value', onChange: onChangeValue, onBlur: () => onBlur(number, hasError), defaultCountry: country, value: number, placeholder: placeholder }))));
};
export default PhoneNumberInput;
